import {DndContext, DndContextProps} from '@dnd-kit/core';

import {useDefaultDndSensors} from '../hooks/useDefaultDndSensors';
import {parseDndItemId} from '../utils/parseDndItemId';

interface DnDContextProps extends DndContextProps {
  children: React.ReactNode;
  onItemDragStart?: (item: ReturnType<typeof parseDndItemId>) => void;
}

export const DnDContext = (props: DnDContextProps) => {
  const sensors = useDefaultDndSensors();

  const {children, ...rest} = props;

  return (
    <DndContext
      sensors={sensors}
      onDragStart={(event) => {
        const item = parseDndItemId(event.active.id);
        if (item) {
          props.onItemDragStart?.(item);
        }
      }}
      {...rest}
    >
      {children}
    </DndContext>
  );
};
